import { InputCheckbox, Label } from "@goodfill/ui-components";
import { FieldGroup } from "../../../../form/FieldGroup";
import { FocusEventHandler, forwardRef, ReactNode, Ref } from "react";

interface FormYesOrNoQuestionProps {
  id: string; // required to avoid collisions in label
  label?: ReactNode;
  subLabel?: ReactNode;
  value: boolean | undefined | null;
  onChange: (value: boolean | undefined) => void;
  validation: string[];
  fill?: boolean;
  onBlur?: FocusEventHandler<HTMLInputElement>;
  ref?: Ref<HTMLInputElement>;
  disabled?: boolean;
  className?: string;
}

interface YesOrNoOption {
  optionId: "Yes" | "No";
  label: string;
  checked: boolean;
  onChange: () => void;
}

export const createYesNoOptions = (
  value: boolean | undefined,
  onChangeState: (value: boolean | undefined) => void,
): YesOrNoOption[] => [
  {
    optionId: "Yes",
    label: "Yes",
    checked: value === true,
    onChange: () => onChangeState(value === undefined ? true : value === false ? true : undefined),
  },
  {
    optionId: "No",
    label: "No",
    checked: value === false,
    onChange: () => onChangeState(value === undefined ? false : value === true ? false : undefined),
  },
];

export const FormYesOrNoQuestion: React.FC<FormYesOrNoQuestionProps> = forwardRef(
  ({ id, label, subLabel, value, onChange, validation, fill, onBlur, className, disabled }, ref) => {
    const normalizedValue = value === null ? undefined : value;
    return (
      <FieldGroup label={label} subLabel={subLabel} validation={validation} className={className}>
        <div className="flex px-2 md:px-3">
          {createYesNoOptions(normalizedValue, onChange).map(({ optionId: optionId, label, checked, onChange }) => {
            const inputId = `${id}${optionId}`;

            return (
              <div key={inputId} className="flex gap-1 items-center">
                <InputCheckbox
                  id={inputId}
                  checked={checked}
                  onChange={onChange}
                  onBlur={onBlur}
                  ref={optionId === "Yes" ? ref : undefined}
                  disabled={disabled}
                />
                <Label htmlFor={inputId} primary={checked}>
                  {label}
                </Label>
              </div>
            );
          })}
        </div>
      </FieldGroup>
    );
  },
);
